import classNames from "classnames";
import React from "react";
import ReactDOM from "react-dom";
import EventListener from "react-event-listener";
import { useElement } from "./Hooks";

interface ModalProps {
  children?: React.ReactNode;
  isModalVisible: boolean;
  modalTitle: React.ReactNode;
  cancelButtonContent?: React.ReactNode;
  submitButtonContent?: React.ReactNode;
  isSubmitting?: boolean;
  onCancel?: any;
  onSubmit: any;
  onClickOutside?: () => void;
}

function ModalInner(props: ModalProps) {
  if (!props.isModalVisible) {
    return null;
  }
  const handleKeyDown = (e: any) => {
    const escapeKeyCode = 27;
    const enterKeyCode = 13;
    switch (e.keyCode) {
      case escapeKeyCode:
        if (props.onClickOutside) {
          props.onClickOutside();
        } else if (props.onCancel) {
          props.onCancel();
        }
        break;
      case enterKeyCode:
        if (!props.isSubmitting) {
          props.onSubmit();
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="modal is-active">
      <EventListener target={document} onKeyDownCapture={handleKeyDown} />
      <div
        className="modal-background"
        onClick={props.onClickOutside || props.onCancel}
      />
      <div className="modal-card">
        <header style={{ overflow: "visible" }} className="modal-card-head">
          <div style={{ maxWidth: "95%" }} className="modal-card-title">
            {props.modalTitle}
          </div>
          <div className="button-wrapper">
            <div
              className="click-catcher"
              onClick={props.onClickOutside || props.onCancel}
              style={{ cursor: "pointer" }}
            />
            <button
              type="button"
              className="delete is-medium"
              disabled={props.isSubmitting}
              onClick={props.onClickOutside || props.onCancel}
            />
          </div>
        </header>
        <section className="modal-card-body">
          <div className="content">{props.children}</div>
        </section>
        <footer
          className="modal-card-foot"
          style={{ justifyContent: "center" }}
        >
          <div className="has-text-centered">
            {props.onCancel && (
              <button
                type="button"
                className="button"
                onClick={props.onCancel}
                disabled={props.isSubmitting}
              >
                {props.cancelButtonContent || "Cancel"}
              </button>
            )}
            <button
              type="button"
              className={classNames("button is-primary", {
                "is-loading": props.isSubmitting,
              })}
              onClick={props.onSubmit}
              disabled={props.isSubmitting}
            >
              {props.submitButtonContent || "OK"}
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
}

export function Modal(props: ModalProps) {
  const target = useElement(document.getElementById("react-modal-root")!, () =>
    document.createElement("div"),
  );

  return ReactDOM.createPortal(<ModalInner {...props} />, target);
}
